import axios from "axios";

const api = process.env.REACT_APP_API_USER || "";
const api_v1 = process.env.REACT_APP_API_USER_v1 || "";

const getUserInfo = async (idUser, token) => {
  try {
    // Consulta el usuario específico utilizando el email
    const usuarioEspecifico = await consultarUsuarioEspecifico(idUser, token);

    const roles = await consultarRolesUsuario(
      usuarioEspecifico.Item.role || "lector",
      token
    );

    const userInfo = usuarioEspecifico.Item; // Podrías querer manipular la respuesta de consultarUsuarioEspecifico antes de asignarla
    const empresa = {}; // Asegúrate de obtener la información de la empresa si es necesario
    const configuracionesEmpresa = {}; // Asegúrate de obtener las configuraciones de la empresa si es necesario

    // Retorna los datos del usuario y sus roles
    return { userInfo, empresa, configuracionesEmpresa, roles };
  } catch (error) {
    console.error("Error al obtener información del usuario:", error);
    throw error; // Lanza el error para que pueda ser manejado por quien llama a esta función
  }
};

const consultarUsuarios = async (token) => {
  const path = `/users`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar actividades:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const consultarUsuarios_v1 = async (token) => {
  const path = `/users`; // Ruta del evento específico
  const apiUrl = `${api_v1}${path}`;

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar actividades:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};
const consultarUsuarioEspecifico = async (email, token) => {
  const path = `/users/${email}`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar actividades:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};
//   try {
//     const response = await axios.get(`${api}/users/${email}`);
//     const data = response.data;
//     return data;
//   } catch (error) {
//     console.error("Error al consultar usuario específico:", error);
//     throw error;
//   }
// };

const EditarUsusairo = async (userId, registro, token) => {
  const path = `/users/${userId}`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.patch(apiUrl, registro, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Devolver los datos obtenidos from Axios response.data
  } catch (error) {
    console.error("Error:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};
const EliminarUsuario = async (userId, token) => {
  const path = `/users/${userId}`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.delete(apiUrl, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Devolver los datos obtenidos from Axios response.data
  } catch (error) {
    console.error("Error:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const subirFotoUsuario = async ({ userId, file, contentType, fileName }, token) => {
  const apiUrl = `${api}/photos`;

  try {
    const response = await axios.post(
      apiUrl,
      { userId, file, contentType, fileName },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error al subir foto:", error);
    throw error;
  }
};

const obtenerUrlFotoUsuario = async (userId, token) => {
  const apiUrl = `${api}/photos/url`;

  try {
    const response = await axios.post(
      apiUrl,
      { userId },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error al obtener url de foto:", error);
    throw error;
  }
};

const consultarRolesUsuario = async (userId, token) => {
  const path = `/roles/${userId}`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar actividades:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const userService = {
  getUserInfo,
  consultarUsuarios,
  consultarUsuarioEspecifico,
  consultarRolesUsuario,
  EditarUsusairo,
  EliminarUsuario,
  consultarUsuarios_v1,
  subirFotoUsuario,
  obtenerUrlFotoUsuario,
};

export default userService;
